import { skipToken, useQuery } from '@tanstack/react-query';

import { Workspaces } from '@air/api';
import { useIsLoggedIn } from '@air/utils-auth';

export const WORKSPACES_LIST_KEY = '@plugin-ui/WORKSPACES_LIST';

type WorkspacesListParams = Parameters<typeof Workspaces.list>[0];

export const getWorkspacesListKey = (
  params?: WorkspacesListParams,
): readonly [typeof WORKSPACES_LIST_KEY, WorkspacesListParams | undefined] => {
  return [WORKSPACES_LIST_KEY, params];
};

export const useWorkspaces = () => {
  const { isLoggedIn } = useIsLoggedIn();

  return useQuery({
    queryFn: isLoggedIn ? () => Workspaces.list() : skipToken,
    queryKey: getWorkspacesListKey(),
  });
};
